import { onError } from '@apollo/client/link/error';

type GraphQLError = {
  extensions?: {
    code?: string;
    response?: { status?: number };
  };
};

type NetworkError = {
  statusCode?: number;
  result?: { errors?: readonly GraphQLError[] } | string;
};

// Authentication takes precedence when a response contains both 401 and 403 errors.
export const createGraphQLErrorLink = (onUnauthenticated: () => void, onForbidden: () => void) =>
  onError(({ graphQLErrors, networkError }) => {
    const network = networkError as NetworkError | null | undefined;
    const result = network?.result;
    const networkErrors = typeof result === 'object' && result !== null && Array.isArray(result.errors) ? result.errors : [];
    const errors = [...(graphQLErrors || []), ...networkErrors];

    if (
      network?.statusCode === 401 ||
      errors.some((error) => error.extensions?.code === 'UNAUTHENTICATED' || error.extensions?.response?.status === 401)
    ) {
      onUnauthenticated();
    } else if (
      network?.statusCode === 403 ||
      errors.some((error) => error.extensions?.code === 'FORBIDDEN' || error.extensions?.response?.status === 403)
    ) {
      onForbidden();
    }
    // Leave the error intact so the caller can stop the operation and handle its state.
  });
